function InfoIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z"
        fill="#4584FF"
      />
      <path
        d="M7.07401 11.874L7.07401 6.42773L8.72831 6.42773L8.72831 11.874L7.07401 11.874ZM8.79276 4.90234C8.8035 5.39648 8.3953 5.79932 7.89042 5.79395C7.41239 5.79932 6.99882 5.39648 6.99882 4.90234C6.99882 4.40283 7.41239 4 7.89042 4C8.3953 4 8.8035 4.40283 8.79276 4.90234Z"
        fill="white"
      />
    </svg>
  );
}

export default InfoIcon;
